import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from "@angular/core";
import { PlatformService } from "@obg/ngx.global.evo";
import { of } from "rxjs";
import { delay, startWith, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-splash-screen",
	templateUrl: "./splash-screen.component.html",
	styleUrls: ["./splash-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SplashScreenComponent {
	@Output() loaded: EventEmitter<void> = new EventEmitter();

	isLoading$ = this.platformService.isBrowser
		? of(false).pipe(
				delay(2000),
				tap(() => this.loaded.emit()),
				startWith(true)
			)
		: of(true);

	constructor(private platformService: PlatformService) {}
}
